import { useState } from "react";
import { TextField, Divider, Button } from "@material-ui/core";
import { Col, Row, Container } from "react-bootstrap";
import ImgComp from "../../utils/ImageComp";
import { updateLab, upload_image_no_id } from "../../../Services/Lab";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import swal from "sweetalert";

const AddCheckUp = ({ location, history }) => {
  let id = localStorage.id
  let info = location.state;
  const dispatch = useDispatch();
  const [blob, setBlob] = useState(null);
  const [title_brief, setTitle_brief] = useState("");
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [price_brief, setPrice_brief] = useState("");
  const [description, setDescription] = useState("");
  const handleSaveBreif = async () => {
    if (title_brief.length > 0 && price_brief.length > 0) {
      try {
        dispatch(showLoading());

        await updateLab({
          add_checkup: {
            is_brief: true,
            price: price_brief,
            title: title_brief,
          },
          id: id,
        });
        swal("success!", "successfully CheckUp created!", "success");
        history.goBack();
      } catch (error) {
        swal("error", error.message, "error");
      } finally {
        dispatch(hideLoading());
      }
    } else {
      swal("error", "please fill all filds", "error");
    }
  };
  const handleSave = async () => {
    if (
      title.length > 0 &&
      price.length > 0 &&
      description.length > 0 &&
      blob
    ) {
      try {
        dispatch(showLoading());
        const fd = new FormData();
        fd.append("img", blob, "jack");
        let { data } = await upload_image_no_id(fd);
        await updateLab({
          add_checkup: {
            is_brief: false,
            price: price,
            title: title,
            content: description,
            img: data.name,
          },
          id: id,
        });
        swal("success!", "successfully CheckUp created!", "success");
        history.goBack();
      } catch (error) {
        swal("error", error.message, "error");
      } finally {
        dispatch(hideLoading());
      }
    } else {
      swal("error", "please fill all filds", "error");
    }
  };
  const handleTitle_b = (e) => {
    setTitle_brief(e.target.value);
  };
  const handleTitle = (e) => {
    setTitle(e.target.value);
  };
  const handlePrice = (e) => {
    setPrice(e.target.value);
  };
  const handlePrice_b = (e) => {
    setPrice_brief(e.target.value);
  };
  const handleDescription = (e) => {
    setDescription(e.target.value);
  };
  return (
    <Container>
      <Row className="justify-content-center">
        <Col md="3">
          <p>Brief</p>
        </Col>
        <Col md="3"></Col>
      </Row>
      <Row className="justify-content-center ">
        <Col md="3">
          <TextField
            variant="outlined"
            value={title_brief}
            onChange={handleTitle_b}
            label="Title"
            size="small"
            fullWidth
          />
        </Col>
        <Col md="3">
          <TextField
            value={price_brief}
            onChange={handlePrice_b}
            variant="outlined"
            label="Price"
            type="number"
            size="small"
            fullWidth
          />
        </Col>
      </Row>
      <Row className="justify-content-center mb-5">
        <Col md="5"></Col>
        <Col md="1" className="mt-4">
          <Button
            onClick={handleSaveBreif}
            fullWidth
            variant="contained"
            color="secondary"
          >
            Save
          </Button>
        </Col>
      </Row>
      <Divider />
      <Row className="justify-content-center mt-5">
        <Col md="3">
          <p>with Description</p>
        </Col>
        <Col md="3"></Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="3">
          <TextField
            variant="outlined"
            value={title}
            onChange={handleTitle}
            label="Title"
            size="small"
            fullWidth
          />
        </Col>
        <Col md="3">
          <TextField
            value={price}
            onChange={handlePrice}
            variant="outlined"
            label="Price"
            type="number"
            size="small"
            fullWidth
          />
        </Col>
      </Row>
      <Row className="justify-content-center mt-5">
        <Col md="6">
          <TextField
            value={description}
            onChange={handleDescription}
            variant="outlined"
            multiline
            rows={4}
            fullWidth
            label="Description"
          />
        </Col>
      </Row>
      <ImgComp loading={false} blob={blob} setBlob={setBlob} />
      <Row className="justify-content-center">
        <Col md="5"></Col>
        <Col md="1" className="mt-4">
          <Button
            onClick={handleSave}
            fullWidth
            variant="contained"
            color="secondary"
          >
            Save
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default AddCheckUp;
